import { render, staticRenderFns } from "./MemberMatch.vue?vue&type=template&id=e9dbf6ac&scoped=true&"
import script from "./MemberMatch.vue?vue&type=script&lang=js&"
export * from "./MemberMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dbf6ac",
  null
  
)

export default component.exports